import React, { useEffect } from 'react';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
interface MetaPixelWindow extends Window {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
}
const PIXEL_ID = '1075305848505674';
export function MetaPixel() {
  useEffect(() => {
    const pixelWindow = window as MetaPixelWindow;
    if (pixelWindow.fbq) {
      pixelWindow.fbq('track', 'PageView');
      return;
    }
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    }) as PixelFunction;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    pixelWindow.fbq = fbq;
    pixelWindow._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.id = 'meta-pixel-script';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-135" data-mp="13j1ggdnuojiz">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-136" data-mp="1idxtd46ltv2e" />
    </noscript>;
}